import React from "react";
import { Instagram } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const INSTAGRAM_URL = "https://www.instagram.com/cpenz.io";

/** Page ending on every route: © in the bottom-left corner, minimal Instagram support icon bottom-right, kept above the floating menu's white fade. */
export default function Footer() {
  const { t, lang } = useLang();
  return (
    <footer className="w-full px-5 pt-10 pb-36 md:pb-6" data-testid="footer">
      <div className="flex items-center justify-between gap-4 text-[11px] text-slate-400 md:fixed md:inset-x-0 md:z-[86] md:px-6 md:pointer-events-none [&>*]:pointer-events-auto" style={{ bottom: "calc(var(--portal-bottom, 2.5rem) + 0.75rem)" }} data-testid="footer-row">
        <span data-testid="footer-rights">© {new Date().getFullYear()} cpenz.io · {t("footer.rights")}</span>
        <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-support" aria-label={lang === "IT" ? "Supporto su Instagram" : "Support on Instagram"} title={lang === "IT" ? "Supporto" : "Support"}
          className="inline-flex h-8 w-8 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-[#f4f6fa] hover:text-[#0b0f1a]">
          <Instagram size={15} />
        </a>
      </div>
    </footer>
  );
}
